import { Box, Typography, Switch, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import DisasterAddButton from "../components/DisasterList/DisasterAddButton";
import DiasterLists from "../components/DisasterList/DiasterLists";
import { grey, green } from "@mui/material/colors";
import { useOneEffect } from "../components/useOneEffect";
import DisasterAddFormModal from "../components/DisasterList/DisasterAddForm";

const switchstyle = { // 패널 확장/접기 스위치 스타일
  backgroundColor: grey[200],
  marginRight: 1,
  marginLeft: 1,
  borderRadius: 3,
};

const dsmgr = { // 재난관리 헤더 스타일
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  textAlign: "center",
  backgroundColor: green[200],
  borderRadius: "3px 3px 0 0",
  marginBottom: 1,
  marginTop: -0.5,
  padding: "8px",
  fontWeight: "bold",
  height: "53px",
  minHeight: "53px",
  boxSizing: "border-box",
  fontSize: "1.25rem",
};

const floatingBaseStyle = { // 재난관리 패널 기본 스타일
  position: "fixed",
  top: "70px",
  left: "10px",
  width: "350px",
  backgroundColor: green[100],
  border: "solid 1px black",
  borderRadius: "8px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
  zIndex: 10,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  transition: "max-height 0.4s ease-in-out",
  height: "fit-content",
};

const SOLO_PANEL_MAX_HEIGHT = "min(415px, 52vh)"; // 해당 재난만 보기 시 창 축소 높이 (하단 여백 최소화)

export const Sidebar = (props) => {
  const [dataChanged, setDataChanged] = useState(false); // 데이터 변경 여부
  const [refresh, setRefresh] = useState(0); // 새로고침 횟수
  const [checked, setChecked] = useState(true); // 패널 확장 여부
  const [showAddModal, setShowAddModal] = useState(false); // 재난등록 모달 창 표시 여부
  const [soloDisasterId, setSoloDisasterId] = useState(null); // 해당 재난만 보기 시 창 축소 재난 ID
  const [showHelp, setShowHelp] = useState(false); // 도움말 창 표시 여부

  const handleDataChange = () => {
    setDataChanged(true);
    handleRefresh();
  };

  const handleRefresh = () => {
    setRefresh(refresh + 1);
  };

  const handleChange = (e) => {
    const ox = e.target.checked;
    setChecked(ox);
    sessionStorage.SidebarPanel = ox;
    props.onExpandChange?.(ox);
  };

  const handleAddDisaster = () => {
    setShowAddModal(true);
  };

  const handleModalClose = () => {
    setShowAddModal(false);
  };

  const handleModalDataChange = () => {
    handleDataChange();
  };

  useOneEffect(() => {
    const ox = props.fullswitch;
    setChecked(ox);
    sessionStorage.SidebarPanel = ox;
    props.onExpandChange?.(ox);
  }, [props.fullswitch]);

  useEffect(() => {
    props.onExpandChange?.(checked);
  }, [checked]);

  
  const headerHeight = checked ? "53px" : "36px"; // 헤더 높이 계산 (확장 시 53px, 접힌 시 36px)
  const isSoloMode = checked && soloDisasterId != null; // 해당 재난만 보기 모드 여부
  const contentMaxHeight = isSoloMode
    ? SOLO_PANEL_MAX_HEIGHT // 해당 재난만 보기 시 창 축소 높이
    : `calc(100vh - ${floatingBaseStyle.top} - 30px)`; // 패널 높이 계산 (전체 뷰포트 높이 - 패널 상단 위치 - 하단 여백)

  return (
    <Box
      id="sidebar"
      sx={{
        ...floatingBaseStyle,
        width: checked ? 350 : "auto",
        minWidth: checked ? 350 : "unset",
        maxHeight: checked ? contentMaxHeight : headerHeight,
        padding: 0,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          ...dsmgr,
          ...(checked
            ? {}
            : {
                padding: "4px 10px",
                marginBottom: 0,
                marginTop: 0,
                height: 36,
                minHeight: 36,
              }),
        }}
      >
        {checked && (
          <Button
            variant="contained"
            size="small"
            onClick={handleAddDisaster}
            sx={{
              padding: "2px 8px",
              minWidth: "auto",
              backgroundColor: green[800],
              color: "white",
              "&:hover": {
                backgroundColor: green[900],
              },
            }}
          >
            재난등록
          </Button>
        )}
        <div>재난관리</div>
        <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <button
            onClick={() => setShowHelp(true)}
            style={{
              width: 18, height: 18, borderRadius: "50%",
              border: "1.5px solid rgba(0,0,0,0.4)",
              backgroundColor: "transparent", color: "rgba(0,0,0,0.6)",
              fontSize: "0.7rem", fontWeight: "bold",
              cursor: "pointer", lineHeight: 1, padding: 0,
              display: "inline-flex", alignItems: "center", justifyContent: "center",
            }}
            title="사용 방법 안내"
          >?</button>
          <Switch
            checked={checked}
            onChange={handleChange}
            sx={{
              ...switchstyle,
              ...(checked ? {} : { marginLeft: 0.5, marginRight: 0 }),
            }}
            size="small"
          />
        </Box>
      </Typography>

      <Box // 재난 목록 영역
        sx={{
          flexGrow: isSoloMode ? 0 : 1,
          overflowX: "hidden",
          overflowY: "auto",
          padding: "0 8px 8px 8px",
          display: "flex",
          //backgroundColor: "red",
          flexDirection: "column",
          minHeight: isSoloMode ? 0 : undefined,
        }}
      >
        {checked && !isSoloMode && ( // 재난 등록 버튼 영역
          <Box component="span" sx={{ display: "none" }}>
            <DisasterAddButton
              onOpenModal={handleAddDisaster}
              onDataChanged={handleDataChange}
              apiAddr={props.apiAddr}
              sx={{ marginBottom: 1 }}
            />
          </Box>
        )}
        {checked && (
          <DiasterLists // 재난 목록 컴포넌트
            refresh={refresh}
            onDataChanged={handleDataChange}
            apiAddr={props.apiAddr}
            onStatus={props.onStatus}
            onSelectDS={props.onSelectDS}
            onShowRDV={props.onShowRDV}
            hdmf={props.hdmf}
            mapfresh={props.mapfresh}
            soloDisasterId={soloDisasterId}
            onSoloChange={setSoloDisasterId}
            onCollapsePanel={() => {
              setChecked(false);
              setSoloDisasterId(null);
              if (typeof sessionStorage !== "undefined")
                sessionStorage.SidebarPanel = "false";
            }}
          />
        )}
      </Box>

      {showAddModal && (
        <DisasterAddFormModal
          open={showAddModal}
          onClose={handleModalClose}
          onDataChanged={handleModalDataChange}
          apiAddr={props.apiAddr}
        />
      )}

      {showHelp && ReactDOM.createPortal(
        <div // 도움말 창 영역
          onClick={() => setShowHelp(false)}
          style={{
            position: "fixed", inset: 0,
            backgroundColor: "rgba(0,0,0,0.55)",
            zIndex: 9999,
            display: "flex", alignItems: "flex-start", justifyContent: "center",
            overflowY: "auto",
            padding: "65px 0 40px",
          }}
        >
          <div // 도움말 창 내용 영역
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "#fff",
              borderRadius: 10,
              padding: "28px 32px",
              maxWidth: 500,
              width: "90%",
              boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
              position: "relative",
            }}
          >
            <button
              onClick={() => setShowHelp(false)}
              style={{
                position: "absolute", top: 12, right: 14,
                background: "none", border: "none",
                fontSize: "1.3rem", cursor: "pointer", color: "#888",
              }}
            >✕</button>

            <h3 style={{ margin: "0 0 16px", color: "#2e7d32", fontSize: "1.05rem", borderBottom: "2px solid #a5d6a7", paddingBottom: 8 }}>
              📋 재난관리 패널 사용법
            </h3>
            <ol style={{ margin: 0, paddingLeft: 20, lineHeight: 2, fontSize: "0.9rem", color: "#333" }}>
              <li><b>[재난등록]</b> 버튼으로 새 재난을 등록합니다</li>
              <li><b>진행단계 필터</b>(본부관리자) — <b>전체 / 진행 / 종료</b>로 재난 목록을 필터링할 수 있습니다</li>
              <li>목록에서 재난을 클릭하면 해당 재난이 <b>활성 재난</b>으로 선택됩니다</li>
              <li>활성 재난의 동원자원·현장·집결지 정보가 지도와 상황판에 반영됩니다</li>
            </ol>

            <hr style={{ margin: "16px 0", borderColor: "#e0e0e0" }} />

            <h3 style={{ margin: "0 0 16px", color: "#1565c0", fontSize: "1.05rem", borderBottom: "2px solid #90caf9", paddingBottom: 8 }}>
              📍 재난현장 및 자원집결지
            </h3>
            <ol style={{ margin: 0, paddingLeft: 20, lineHeight: 2, fontSize: "0.9rem", color: "#333" }}>
              <li>재난 선택 후 <b>재난현장 추가</b>로 현장 위치를 등록합니다</li>
              <li>재난현장의 <b>[출퇴근QR]</b>로 지원인력 출퇴근 관리 QR을 생성합니다</li>
              <li>자원집결지도 동일하게 <b>출퇴근QR</b> 및 <b>지원인력 상황판</b>과 연동됩니다</li>
            </ol>

            <hr style={{ margin: "16px 0", borderColor: "#e0e0e0" }} />

            <p style={{ margin: 0, fontSize: "0.82rem", color: "#888", lineHeight: 1.9 }}>
              🔵 <b>[온/오프 토글]</b> — 패널 접기·펼치기 &nbsp;|&nbsp;
              ➕ <b>[재난등록]</b> — 새 재난 등록 화면 열기
            </p>
          </div>
        </div>,
        document.body
      )}
    </Box>
  );
};
